var map = {
	"./design_1/single-page/home": [
		"7983",
		"chunk-2af188cc"
	],
	"./design_2/single-page/home": [
		"8251",
		"chunk-b4a0999c",
		"chunk-3d5857db"
	],
	"./findoctor/single-page/home": [
		"225e",
		"chunk-beb6f1a4",
		"chunk-52ce2108"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "01a8";
module.exports = webpackAsyncContext;